import { render, staticRenderFns } from "./VacanciesCompanyVacanciesBlock.vue?vue&type=template&id=0bb354de&scoped=true&"
import script from "./VacanciesCompanyVacanciesBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesCompanyVacanciesBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesCompanyVacanciesBlock.vue?vue&type=style&index=0&id=0bb354de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb354de",
  null
  
)

export default component.exports